import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-164">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-165">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="absolute inset-0 bg-navy/80 backdrop-blur-sm" onClick={onClose} data-id="element-166" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-167">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 shrink-0" data-id="element-168">
              <h2 className="text-xl font-bold text-navy" data-id="element-169">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 transition-colors text-slate-500 hover:text-navy" aria-label="Cerrar" data-id="element-170">
                <XIcon className="w-5 h-5" data-id="element-171" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto text-slate-700 leading-relaxed text-sm space-y-4" data-id="element-172">
              {children}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-slate-100 shrink-0" data-id="element-173">
              <button onClick={onClose} className="w-full py-3 rounded-full bg-navy text-white font-medium hover:bg-navy/90 transition-colors text-sm" data-id="element-174">
                Cerrar
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}